import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=74a61766&"
import script from "./Others.vue?vue&type=script&lang=ts&"
export * from "./Others.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports